import styled from "@emotion/styled";
import * as React from "react";

import { ChevronDown } from "@livechat/design-system-icons";
import { DesignToken, Icon, RadiusToken, SpacingToken, Text } from "@livechat/design-system-react-components";

import { Collapse } from "components/collapse";
import { withVar } from "themes/helpers";

interface ISectionState {
  collapsed: boolean;
}

interface ISectionProps {
  title: string;
  onCollapseChange?(collapsed: boolean): void;
  children: React.ReactNode;
}

export default class Section extends React.PureComponent<ISectionProps, ISectionState> {
  state = { collapsed: false };

  handleTitleClick = (): void => {
    this.setState(
      prevState => ({
        collapsed: !prevState.collapsed,
      }),
      () => {
        if (this.props.onCollapseChange) {
          this.props.onCollapseChange(this.state.collapsed);
        }
      }
    );
  };

  render(): JSX.Element {
    return (
      <>
        <Title onClick={this.handleTitleClick}>
          <RotatingChevron size="small" rotated={this.state.collapsed} source={ChevronDown} />
          <Text size="sm">{this.props.title}</Text>
        </Title>
        <Collapse collapsed={this.state.collapsed}>{this.props.children}</Collapse>
      </>
    );
  }
}

const RotatingChevron = styled(Icon)<{ rotated: boolean }>`
  transform: rotate(${({ rotated }): string => (rotated ? "-90deg" : "0")});
  transition: transform 0.2s ease-in-out;
  margin-left: var(${SpacingToken.Spacing1});
  margin-right: var(${SpacingToken.Spacing1});
`;

const Title = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  background-color: ${withVar(DesignToken.SurfaceSecondaryDefault)};
  border-radius: var(${RadiusToken.Radius3});
  color: ${withVar(DesignToken.ContentBasicPrimary)};
  padding: var(${SpacingToken.Spacing1});

  user-select: none;
  cursor: pointer;
`;
